import React, { useContext } from 'react';
import './profile.css';
import './companyProfileForm.css';
// import useS3Upload from '../../../../../hooks/aws/useS3Upload';
// import useWasabiUpload from '../../../../../hooks/aws/useWasabiUpload';
import LocationInput from './LocationInput';
import LogoUploader from './LogoUploader';
import GalleryUploader from './GalleryUploader';
import useCsrfToken from '../../../../../hooks/csrf/useCsrfToken';
import { useAuth } from '../../../../../context/AuthContext';
import { useCompanyForm } from '../../../../../hooks/useCompanyForm';
import { COMPANY_FORM_INITIAL_STATE, BENEFIT_OPTIONS, CHILEAN_REGIONS, SANTIAGO_COMMUNES } from '../../../../../constants/formInitialStates';

const CompanyProfileForm = ({ onFormSubmit, initialValues, isNewRestaurant, restaurantId }) => {
  const { setUserInfo } = useAuth();

  const csrfProtectionToken = useCsrfToken();

  const { 
    state, 
    setState, 
    uploading, 
    errors, 
    setErrors, 
    galleryFiles,
    setGalleryFiles,
    logoFile,
    handleSubmit: submitForm,
    handleLogoUpload,
    handleCarouselPhotoUpload,
    handleRemoveGalleryPhoto
  } = useCompanyForm({
    initialState: COMPANY_FORM_INITIAL_STATE,
    initialValues,
    restaurantId,
    onFormSubmit,
    setUserInfo
  });

  const regiones = CHILEAN_REGIONS;
  const comunasSantiago = SANTIAGO_COMMUNES;

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value
    }));
  };


  const formatBenefitLabel = (benefit) => {
    const benefitOption = BENEFIT_OPTIONS.find(option => option.key === benefit);
    return benefitOption ? benefitOption.label : benefit.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\b\w/g, (match) => match.toUpperCase());
  };

  const addLocation = () => {
    setState((prevState) => ({
      ...prevState,
      locations: [...prevState.locations, { address: "", longitude: "", latitude:""}]
    }));
  };

  const removeLocation = (index) => {
    setState((prevState) => {
      const newLocations = prevState.locations.filter((_, i) => i !== index);

      return {
        ...prevState,
        locations: newLocations,
      };
    });
  };

  const updateLocation = (prevState, index, updatedLocation) => {
    const updatedLocations = prevState.locations.map((location, i) =>
      i === index ? { ...location, ...updatedLocation } : location
    );

    return { ...prevState, locations: updatedLocations };
  };

  const updateBenefits = (e) => {
    const benefitName = e.target.name;
    const isChecked = e.target.checked;

    setState((prevState) => ({
      ...prevState,
      benefits: {
        ...prevState.benefits,
        [benefitName]: isChecked,
      },
    }));
  };

  const validateFields = (state) => {
    const fields = [
      { name: 'legalName', message: 'El nombre legal es obligatorio' },
      { name: 'rut', message: 'La rut es obligatorio' },
      { name: 'name', message: 'El nombre es obligatorio' },
      { name: 'format', message: 'La formato es obligatorio' },
      { name: 'specialty', message: 'La especialidad es obligatoria' },
      { name: 'region', message: 'La region es obligatoria' },
      { name: 'numberOfRestaurants', message: 'La cantidad de locales es obligatorio' },
      { name: 'workers', message: 'La cantidad de trabajadores' },
      { name: 'weeklyAverageClients', message: 'El número de clientes es obligatorio' },
      // { name: 'profileImageUrl', message: 'La foto es obligatoria' }, // Made optional for testing
      { name: 'description', message: 'La descripción es obligatoria' },
    ];

    const errors = {};

    fields.forEach((field) => {
      if (!state[field.name]) {
        errors[field.name] = field.message;
      } 
    });

    return errors;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Note: profileImage errors are now warnings only and don't block submission
    
    await submitForm(validateFields);
  };

  const handleFormatLabel = (label) => {
    return label.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
  }

  return (
    <form onSubmit={handleSubmit} id="profile-form">
     {/* Logo */}
     <LogoUploader 
       onUpload={handleLogoUpload} 
       uploading={uploading} 
       uploadError={null} 
       profileImageUrl={state.profileImageUrl}
       imageError={errors.profileImage}
     />

      {/* Inputs */}
      <div className='company-profile-form__inputs'>
        <div className="company-profile-form__group">
          <label>
            Razón Social:
          </label>
          <input
            type="text"
            value={state.legalName}
            className="company-profile-form__input"
            onChange={(e) => setState((prevState) => ({ ...prevState, legalName: e.target.value }))}
          />
          {errors.legalName && <span className="company-profile-form__error-message">{errors.legalName}</span>}
        </div>

        <div className="company-profile-form__group">
          <label>
            Rut empresa:
          </label>
          <input
              type="text"
              value={state.rut}
              className="company-profile-form__input"
              onChange={(e) => setState((prevState) => ({ ...prevState, rut: e.target.value }))}
            />
            {errors.rut && <span className="company-profile-form__error-message">{errors.rut}</span>}
        </div>

        <div className="company-profile-form__group">
          <label>
            Nombre empresa:
          </label>
          <input
              type="text"
              value={state.name}
              className="company-profile-form__input"
              onChange={(e) => setState((prevState) => ({ ...prevState, name: e.target.value }))}
          />
          {errors.name && <span className="company-profile-form__error-message">{errors.name}</span>}
        </div>

        <div className="company-profile-form__group">
        <label htmlFor="region">Región:</label>
        <select
          id="region"
          value={state.region}
          onChange={handleChange}
          className="company-profile-form__input"
        >
          <option value="">Selecciona una región</option>
          {regiones.map((region, index) => (
            <option key={index} value={region}>{region}</option>
          ))}
        </select>
        {errors.region && <span className="company-profile-form__error-message">{errors.region}</span>}
        </div>

        <div className="company-profile-form__group">
          <label htmlFor="comuna">Comuna:</label>
          <select
            id="comuna"
            value={state.comuna}
            onChange={handleChange}
            disabled={state.region !== "Metropolitana"}
            className="company-profile-form__input"
          >
            <option value="">Selecciona una comuna</option>
            {state.region === "Metropolitana" &&
              comunasSantiago.map((comuna, index) => (
                <option key={index} value={comuna}>{comuna}</option>
              ))}
          </select>
          {errors.comuna && <span className="company-profile-form__error-message">{errors.comuna}</span>}
        </div>

        <div className="company-profile-form__group">
          <label>Tipo de empresa:</label>
          <select
            value={state.format}
            className="company-profile-form__input"
            onChange={(e) =>
              setState((prevState) => ({ ...prevState, format: e.target.value }))
            }
          >
            <option value="">Selecciona un tipo de empresa</option>
            <option value="Restaurante">Restaurante</option>
            <option value="Fastfood">Fastfood</option>
            <option value="Bar">Bar</option>
            <option value="Pub">Pub</option>
            <option value="Restobar">Restobar</option>
            <option value="Cafeteria">Cafetería</option>
            <option value="Pasteleria">Pastelería</option>
            <option value="Heladeria">Heladería</option>
            <option value="Panaderia">Panadería</option>
            <option value="Foodtruck">Foodtruck</option>
            <option value="Hotel">Hotel</option>
            <option value="Banquetera">Banquetería</option>
            <option value="Casino">Casino</option>
            <option value="Dark Kitchen">Dark Kitchen</option>
            <option value="Otro">Otro</option>
          </select>
          {errors.format && <span className="company-profile-form__error-message">{errors.format}</span>}
        </div>

        <div className="company-profile-form__group">
          <label htmlFor="specialty">Especialidad:</label>
          <select
            id="specialty"
            value={state.specialty}
            className="company-profile-form__input"
            onChange={(e) =>
              setState((prevState) => ({ ...prevState, specialty: e.target.value }))
            }
          >
            <option value="">Selecciona una especialidad</option>
            <option value="Comida India">Comida India</option>
            <option value="Comida China">Comida China</option>
            <option value="Comida Americana">Comida Americana</option>
            <option value="Comida vegetariana">Comida vegetariana</option>
            <option value="Comida Francesa">Comida Francesa</option>
            <option value="Comida arabe">Comida árabe</option>
            <option value="Comida mediterranea">Comida mediterránea</option>
            <option value="Comida Peruana">Comida Peruana</option>
            <option value="Comida Mexicana">Comida Mexicana</option>
            <option value="Comida Internacional">Comida Internacional</option>
            <option value="Comida Criolla">Comida Criolla</option>
            <option value="Comida Italiana">Comida Italiana</option>
            <option value="Comida Cubana">Comida Cubana</option>
            <option value="Comida Española">Comida Española</option>
            <option value="Comida Colombiana">Comida Colombiana</option>
            <option value="Comida tradicional">Comida tradicional</option>
            <option value="Comida Japonesa">Comida Japonesa</option>
            <option value="Parrillada">Parrillada</option>
            <option value="Pescados y Mariscos">Pescados y Mariscos</option>
            <option value="Sangucheria">Sanguchería</option>
            <option value="Wine Bar">Wine Bar</option>
            <option value="Cafetería">Cafetería</option>
            <option value="Hamburguesería">Hamburguesería</option>
          </select>
          {errors.specialty && <span className="company-profile-form__error-message">{errors.specialty}</span>}
        </div>

        <div className="company-profile-form__group">
          <label>
            Cantidad de locales:
          </label>
          <input
              type="text"
              className="company-profile-form__input"
              value={state.numberOfRestaurants}
              onChange={(e) => setState((prevState) => ({ ...prevState, numberOfRestaurants: e.target.value }))}
          />
          {errors.numberOfRestaurants && <span className="company-profile-form__error-message">{errors.numberOfRestaurants}</span>}
        </div>

        <div className='company-profile-form__group'>
          <label>Cantidad de clientes</label>
          <select
            value={state.weeklyAverageClients}
            className="company-profile-form__input"
            onChange={(e) => setState((prevState) => ({ ...prevState, weeklyAverageClients: e.target.value }))}
          >
            <option value="">Selecciona la cantidad de clientes</option>
            <option value="0-50">0-50</option>
            <option value="50-100">50-100</option>
            <option value="100-200">100-200</option>
            <option value="200-300">200-300</option>
            <option value="300-400">300-400</option>
            <option value="400+">Más de 400</option>
          </select>
          {errors.weeklyAverageClients && <span className="company-profile-form__error-message">{errors.weeklyAverageClients}</span>}
        </div>

        <div className="company-profile-form__group">
          <label>
            Cantidad trabajadores:
          </label>
          <select
            value={state.workers}
            onChange={(e) => setState((prevState) => ({ ...prevState, workers: e.target.value }))}
            className="company-profile-form__input"
          >
            <option value="">Selecciona la cantidad de trabajadores</option>
            <option value="0-50">0-50</option>
            <option value="50-100">50-100</option>
            <option value="100-200">100-200</option>
            <option value="200-300">200-300</option>
            <option value="300-400">300-400</option>
            <option value="400+">Más de 400</option>
          </select>
          {errors.workers && <span className="employee-profile-form__error-message">{errors.workers}</span>}
        </div>
      </div>

      <div className='company-profile-form__description-container'>
        <label>
          Descripción empresa:
        </label>
        <textarea
            id="description-input"
            className="company-profile-form__input"
            value={state.description}
            onChange={(e) => setState((prevState) => ({ ...prevState, description: e.target.value }))}
        />
        {errors.description && <span className="company-profile-form__error-message">{errors.description}</span>}
      </div>

      {/* Beneficios */}
      <div className="company-profile-form__title-checkbox-container">
        <h2>Beneficios</h2>
        <div className="company-profile-form__checkbox-grid">
            {Object.keys(state.benefits).map((benefit, index) => (
              <div key={benefit} className="company-profile-form__checkbox-container">
                <input
                  id={`benefit-check-box-${index}`}
                  name={benefit}
                  type="checkbox"
                  checked={state.benefits[benefit]}
                  onChange={updateBenefits}
                />
                <label htmlFor={`benefit-check-box-${index}`}>
                  {handleFormatLabel(benefit)}
                </label>
              </div>
            ))}
        </div>
      </div>

      {/* Gallery */}
      <div className="company-profile-form__gallery-container">
        <h2>Galería de Fotos</h2>
        <GalleryUploader
          onUpload={handleCarouselPhotoUpload}
          uploading={uploading}
          uploadError={null}
          photoUrls={state.profileCarouselUrls}
          setPhotoUrls={(newUrls) => {
            setState((prevState) => ({
              ...prevState,
              profileCarouselUrls: newUrls,
            }));
            // Also remove corresponding files from galleryFiles
            setGalleryFiles(prevFiles => prevFiles.slice(0, newUrls.length));
          }}
          onRemovePhoto={handleRemoveGalleryPhoto}
        />
      </div>

      {/* Ubicaciones */}
      <div className="company-profile-form__location-add-container">
        <h2>Ubicaciones</h2>
        <button type="button" className="company-profile-form__add-button" onClick={addLocation}>
          + Agregar ubicación
        </button>
      </div>
      <div className="company-profile-form__location-container">
        {state.locations.map((location, index) => (
          <LocationInput
            key={index}
            location={location}
            index={index}
            setState={setState}
            updateLocation={updateLocation}
            removeLocation={removeLocation}
            addLocation={addLocation}
          />
        ))}
      </div>

      <div className="company-profile-form__button-container">
        <button type="submit" className="company-profile-form__submit-button">{initialValues ? 'Actualizar' : 'Crear'}</button>
      </div>

    </form>
  );
};

export default CompanyProfileForm;